const scopes = {
    create: ['campaign', 'offer', 'drawing', 'drawingResult', 'reward', 'allUsers', 'message'],
    read: ['campaign', 'offer', 'drawing', 'reward', 'allUsers', 'message', 'template'],
    update: ['campaign', 'offer', 'drawing'],
    delete: ['campaign','offer']
}

export function getScope(){
    let scope ='';
    const keys = Object.keys(scopes);
    keys.map(x=>{
        scopes[x].map(y =>{
            scope += `${x}:${y} `;
        })
    })
    return scope;
  }